var { cELM, guidGenerator, httpGet, get, Wrap4Arrow, dataURItoBlob, getChatURL, getAnswerVariableCssClass } = require("../utils");
var { url } = require("../config");
var Scroller = require("../components/scroller");
var Chat = require("../chat");
var Provider = require("../components/blocks/provider");
var Question = require("../components/blocks/question");
const InsuranceQuestion = require("../components/blocks/insurance-question");
const UploaderControl = require("./uploader-control");
const {predictSharpness, filters} = require('./helpers/imageProcessing');
const Laplacian = filters.laplacian;

class ImageModule {
  constructor(type, value) {
    const _self = this;
    this.type = type;
    this.value = value;
    this._files = null;
    this._timer = null;
    this.supportedTypes = "image/png,image/gif,image/jpeg"; //Removed PDF support for now (application/pdf)
    this.fileUploadedName = null;
    this._interalModuleId = guidGenerator();
    this.elements = {
      _questionBlock: null,
      _uploadContainerEl: null,
      _inputEl: null,
      _btnEl: null,
      _percentEl: null,
      _loadingBl: null,
      _answerBlockEl: null,
      _errorServerProcessingEl: null,
      _skipBtn: null
    };

    this.language = {
      continue: getLngTxt('button.continue'),
      skip: getLngTxt('button.skip'),
      takeOrUpload: getLngTxt('button.takeOrUpload'),
      retake: getLngTxt('button.retake'),
      cancel: getLngTxt('button.cancel'),
      blurry: getLngTxt('imageUpload.blurry'),
      slightlyBlurry: getLngTxt('imageUpload.slightlyBlurry'),
      blurrySubtext: getLngTxt('imageUpload.blurrySubtext'),
      takePicture: getLngTxt('imageUpload.takePicture'),
      cameraFeedText: getLngTxt('imageUpload.cameraFeedText'),
      cameraFeedSubtext: getLngTxt('imageUpload.cameraFeedSubtext')
    };

    const cssVariableKey = getAnswerVariableCssClass(value);

    this.elContainer = cELM("div", `component-block upload ${cssVariableKey}`);
    this.elContainer.addELM(new Provider({ data: value }));

    let _qBl = null;
    console.log(value);
    if (get(value, "format", "").includes("image-upload-insurance")) {
      _qBl = new InsuranceQuestion({
        data: value
      });
      this.elContainer.addELM(_qBl);
    }
    else if (get(value, "values.file.finalURL")) {
      _qBl = new Question({
        data: {
          text: get(value, "values.text.content", ""),
          subtext: get(value, "values.subtext"),
        },
      });
      this.elContainer.addELM(_qBl);
    } else {
      _qBl = new Question({ data: value });
      this.elContainer.addELM(_qBl);
    }
    this.elements._questionBlock = _qBl;

    const img = cELM("img", "image-area");
    img.style.display = "none";

    this.elements._img = img;

    const _errorServerProcessingEl = cELM("div", "error-processing", getLngTxt('imageUpload.couldntProcess'));
    _errorServerProcessingEl.style.display = "none";
    this.elContainer.addELM(_errorServerProcessingEl);
    this.elements._errorServerProcessingEl = _errorServerProcessingEl;

    const answerBlock = this.addAnswerBlock();
    this.elements._answerBlockEl = answerBlock;

    // Different order for insurance upload
    if (get(value, "format", "").includes("image-upload-insurance")) {
      this.elContainer.addELM(answerBlock);
      this.elContainer.addELM(img);
      answerBlock.classList.add("insurance"); // TEST THIS
    }
    else {
      this.elContainer.addELM(img);
      this.elContainer.addELM(answerBlock);
    }
;

    const _unsupportedFileTypeEl = cELM("div", "unsupported-image", getLngTxt('imageUpload.unsupportedFileType'));
    _unsupportedFileTypeEl.style.display = "none";
    this.elContainer.addELM(_unsupportedFileTypeEl);
    this.elements._unsupportedFileTypeEl = _unsupportedFileTypeEl;


    this.addProcessedForm();
    this.addVideoFeedBlock();

    if (this.value.format == "image-upload" || this.value.format == "image-upload-insurance-front" || this.value.format == "image-upload-insurance-back") {
      this.getComponent("div.continue-button").parentNode.style.display = "none";
    }

    this.control = new UploaderControl({ delegate: this });
  }

  addProcessedForm() {

    var _continue = this.language.continue || "Continue";

    var formBl = cELM("div", "option-block form")
    this.elContainer.addELM(formBl);

    this.elContainer.addELM(formBl);
    this.elements._formBl = formBl;
    const _continueElement = cELM("div", "continue-button continue-button-inactive", _continue);
    this._continueEnabled = true;
    var _submitEl = Wrap4Arrow(
      _continueElement,
      true,
    );
    this.elContainer.addELM(_submitEl);

    var _self = this;

    _submitEl.onclick = function () {
      if (!_self._continueEnabled) {
        return;
      }

      Chat.default.send(
        {
          id: (_self.value || {}).id,
          meta: {
            fields: [],
            type: "image-upload",
          },
          status: "processed-validated",
        },
        null,
        _self.elContainer,
      );
      _self.hideAnswers();
    }

    this.elements._submitEl = _submitEl;
    this.elements._continue = _continueElement;
  }

  addVideoFeedBlock() {
      // Check if the video element is compatible with the browser!!! TODO
      const _self = this;

      // Video feed
      const videoWrapperElement = cELM('div', 'video-feed-wrapper inactive');
      const videoOverlayElement = cELM('div', 'video-feed-guide');
      if (_self.value.format.includes('front')) {
        videoOverlayElement.classList.add('front');
      }
      else {
        videoOverlayElement.classList.add('back');
      }

      const videoElement = cELM('video', 'video-feed');
      videoElement.setAttribute('playsinline', '');
      const videoContainer = cELM('div', 'video-container');
      videoContainer.addELM(videoWrapperElement);
      videoWrapperElement.addELM(videoElement);
      videoWrapperElement.addELM(videoOverlayElement);
      this.elContainer.addELM(videoContainer);
      this.elements._videoWrapper = videoWrapperElement;
      this.elements._video = videoElement;

      // Create canvas used for taking the picture
      const canvas = cELM('canvas', 'video-feed-canvas');
      this.elContainer.addELM(canvas);
      this.elements._canvas = canvas;

      // Configure canvas
      videoElement.addEventListener('canplay', () => {
        let width = + window.getComputedStyle(videoElement, null).getPropertyValue('width').replace('px', '');
        let height = + window.getComputedStyle(videoElement, null).getPropertyValue('height').replace('px', '');
        canvas.setAttribute('width', width);
        canvas.setAttribute('height', height);
      });

      const takePictureButton = cELM("div", "take-picture-button inactive", this.language.takePicture);
      takePictureButton.addEventListener('click', (event) => {
        _self.takePictureAndUpload();
        // _self.closeCameraFeed(); // Leave camera feed open for the next questions
        _self.hideCameraFeedQuestion();
        event.preventDefault();
      });
      this.elContainer.addELM(takePictureButton);
      this.elements._takePicture = takePictureButton;
  }

  addAnswerBlock() {
    var _self = this;

    var retake = this.language.retake || "Retake";
    var takeOrUpload = this.language.takeOrUpload || "Take or upload picture";

    let skip = this.language.skip || "Skip";
    if (this.value.format && this.value.format === 'image-upload-insurance-front') {
      skip = this.language.cancel || "Cancel"
    }

    var oBlock = cELM("div", "option-block controls");
    var _btnEl = cELM(
      "div",
      "button",
      get(this.value, "values.file.finalURL") ? retake : takeOrUpload,
    );
    var _inputEl = cELM("input", "input-file");

    _inputEl.setAttribute("multiple", false);
    _inputEl.setAttribute("accept", _self.supportedTypes);
    _inputEl.setAttribute("type", "file");
    _inputEl.style.display = "none";

    var _uploadContainerEl = cELM("div", "inputs-wrapper");
    var _loadingBl = cELM("div", "loading-block", null, null, "img-loading-block-1");
    _loadingBl.style.display = "none";

    var _percentEl = cELM("div", "percent", "0%");
    _loadingBl.addELM(_percentEl);

    var _skipBtnEl = cELM("div", "button inactive", skip);
    var _row = cELM("div", "upload-actions");
    _row.addELM(cELM("div", "button blank"));
    _row.addELM(_btnEl);
    _row.addELM(_skipBtnEl);

    _uploadContainerEl.addELM(_loadingBl);
    _uploadContainerEl.addELM(_row);
    this.elements._uploadActions = _row;

    _skipBtnEl.onclick = function(evt) {
      if(_self.elements._skipBtn.className.indexOf('uploading') > -1){
        return;
      }

      _self.elContainer.classList.add('image-skipped');
      _self.restoreEditButtonsClick();
      _self.elements._errorServerProcessingEl.style.display = "none";

      // We want the cancel click to be saved as a different event
      // so as to display a confirmation question in the questionnaire
      let answerType = 'unknown';
      // If the image was uploaded successfully or we are asking for the front image
      if (_self.sucessfulUpload || _self.value.format && _self.value.format === 'image-upload-insurance-front') {
        answerType = 'cancel'
      }

      Chat.default.send(
        {
          meta: {
            type: answerType,
            isRetake: _self.isRetake,
            fields: []
          },
          id: (_self.value || {}).id,
          status: "processed-validated",
          name: _self.fileUploadedName
        },
        null,
        _self.elContainer,
      );

      _self.hideAnswers();
    };

    _inputEl.onchange = function(e) {
      _self.elements._errorServerProcessingEl.style.display = "none";
      _unsupportedEl = _self.getComponent("div.unsupported-image");
      var types = _self.supportedTypes.split(",");
      if (this.files[0]) {
        if (types.indexOf(this.files[0].type) > -1) {
          _self.preventEditButtonsClick();
          _self.disableSkipButton();
          _unsupportedEl.style.display = "none";
          _self._files = this.files;
          _self.control.queue(this);
          _self.control.processQueue(undefined, "aws", "nonlambda/");
        } else {
          _unsupportedEl.style.display = "block";
        }
      }
    };

    _btnEl.onclick = function(evt) {
      if (_self.value.format && _self.value.format.includes('image-upload-insurance')) {
        if (!window.mediaStream) {
          _inputEl.click();
        }
        else {
          if (_self.playing) {
            _self.showCameraFeedQuestion();
            return
          }

          _self.startCapture(window.mediaStream)
          .then(() => {
            _self.playing = true;
            _self.showCameraFeedQuestion();
          })
          .catch(() => {
            _inputEl.click();
          })
        }
      }
      else {
        _inputEl.click();
      }
    };

    oBlock.addELM(_uploadContainerEl);
    oBlock.addELM(_inputEl);

    this.elements._uploadContainerEl = _uploadContainerEl;
    this.elements._inputEl = _inputEl;
    this.elements._btnEl = _btnEl;
    this.elements._percentEl = _percentEl;
    this.elements._loadingBl = _loadingBl;
    this.elements._skipBtn = _skipBtnEl;

    return oBlock;
  }

  enableContinue() {
    if (this.elements._continue) {
      this.elements._continue.classList.remove('continue-button-inactive');
      this.elements._continue.classList.add('continue-button-active');
      this._continueEnabled = true;
      const arrow = this.getComponent('img.arrow');
      arrow.style.visibility = 'visible';
      arrow.style.display = 'block';
      this.elements._continue.style.display = 'block';
    }
  }

  disableContinue() {
    if (this.elements._continue) {
      this.elements._continue.classList.remove('continue-button-active');
      this.elements._continue.classList.add('continue-button-inactive');
      this._continueEnabled = false;
      const arrow = this.getComponent('img.arrow');
      arrow.style.visibility = 'hidden';
      arrow.style.display = 'block';
      this.elements._continue.style.display = 'block';
    }
  }

  imageCompleted() {
    const _self = this;
    // when upload completed and processed
    _self._percent = 100;
    _self._maxPercent = 100;
    clearInterval(_self._interval);
    _self.updateProgress();

    const retake = _self.language.retake || "Retake";
    _self.isRetake = true;

    this.elements._btnEl.style.display = "block";
    this.elements._img.style.display = "block";
    document.getElementById("img-loading-block-1").style.display = "none";
    this.getComponent("div.option-block.form").style.display = "block";
    this.getComponent("div.continue-button").parentNode.style.display = "block";
    this.elements._btnEl.innerHTML = retake;
    this.elements._uploadActions.classList.remove('inactive');

    // Rename skip for insurance uploader
    if (this.value.format.includes("image-upload-insurance")) {
      // Override onclick and rename to Cancel
      this.elements._skipBtn.innerHTML = this.language.cancel || "Cancel";
    }

    this.sucessfulUpload = true;
  }

  checkBlurriness(img, value) {
    const _self = this;
    const handleBlurry = () => {
      const block = new Question({
        data: {
          text: _self.language.blurry,
          subtext: _self.language.blurrySubtext
        }
      });
      _self.elements._questionBlock.elm.innerHTML = block.getHTML().innerHTML;
      _self.disableContinue();
    };
    const handleSlightlyBlurry = () => {
      const block = new Question({
        data: {
          text: _self.language.slightlyBlurry,
          subtext: _self.language.blurrySubtext
        }
      });

      _self.elements._questionBlock.elm.innerHTML = block.getHTML().innerHTML;
      _self.disableContinue();
    };

    const handleClearImage = () => {
      const block = new Question({
        data: {
          text: get(value, "values.text.content", ""),
          subtext: get(value, "values.subtext"),
        },
      });

      _self.elements._questionBlock.elm.innerHTML = block.getHTML().innerHTML;
      _self.enableContinue();
    };

    const processBlurriness = (threshold, prediction) => {
      if (threshold == -1) {
        if (prediction == -1) {
          handleBlurry()
        } else if (prediction == 0) {
          handleSlightlyBlurry();
        }
        else {
          handleClearImage();
        }
      } else {
        if (prediction == -1) {
          handleBlurry()
        } else {
          handleClearImage();
        }
      }
    }

    img.addEventListener('load', ()=> {
      var uploadedImage = _self.elements._img;

      if (uploadedImage.src && uploadedImage.complete && uploadedImage.naturalHeight!=0) {
        try {
          if (!window.disableBlurryDetection) {
            var prediction = predictSharpness(Laplacian, uploadedImage);

            if (prediction == undefined) {
              return;
            }

            var threshold = window.strictBlurryDetectionThreshold ? -1 : 0;
            console.log("PREDICTION", prediction, "THRESHOLD", threshold);
            processBlurriness(threshold, prediction);

          } else {
            console.log('Disabled blurry detection');
            _self.enableContinue();
          }
        } catch(e) {
          console.log("Failed to process blurry detection in the client")

          var hashImage = (uploadedImage.src || '').split('/').pop()
          if (hashImage && !window.disableBlurryDetection) {
            httpGet(url + "/api/image/sharpness/" + hashImage, {}, function (result) {
              prediction = result.prediction;
              var threshold = window.strictBlurryDetectionThreshold ? -1 : 0;
              console.log("PREDICTION AT SERVER", prediction, "THRESHOLD", threshold);
              processBlurriness(threshold, prediction);
            });
          }
        }
        finally {
          _self.imageCompleted();
        }
      } else {
        _self.imageCompleted();
        handleClearImage();
      }
    });
  }

  handle(value) {
    switch (value.format) {
      case "onimageupload-started":
        this.handleUploadStarted(value);
        break;
      case "onimageupload-uploaded":
        this.handleUploaded(value);
        break;
      case "onimageupload-resized":
        this.handleResized(value);
        break;
      case "onimageupload-processed":
        this.handleProcessed(value);
        break;
      default:
        break;
    }
  }

  preventEditButtonsClick() {
    const buttons = document.getElementsByClassName('edit-active');
    for (const button of buttons) {
      button.style['pointer-events'] = 'none';
    }
  }

  restoreEditButtonsClick() {
    const buttons = document.getElementsByClassName('edit-active');
    for (const button of buttons) {
      button.style['pointer-events'] = 'all';
    }
  }

  getELM() {
    return this.elContainer;
  }

  getHTML() {
    return this.elContainer;
  }

  reset() {}

  focus() {}

  scrollToElement() {
    Scroller.scrollToElm(this);
  }

  handleUploadError(result) {
    this.restoreEditButtonsClick();
    this.elements._loadingBl.style.display = "none";

    this.getComponent(".option-block.controls").style.display = "block";
    this.getComponent(".option-block.form").style.display = "block";

    this.elements._errorServerProcessingEl.style.display = "block";
    this.elements._btnEl.style.display = "block";
    this.elements._inputEl.value = "";
    this.elements._uploadActions.classList.remove('inactive');

    if(Sentry && Sentry.captureException) {
        Sentry.captureException(`Error uploading image: ${JSON.stringify(result)}`);
    }
  }

  handleUploadStarted(value) {
    if (this.value.format && this.value.format.includes('image-upload-insurance')) {
      const qBl = new Question({
        data: {
          text: value.text
        }
      });

      this.elements._questionBlock.elm.innerHTML = qBl.getHTML().innerHTML;
      this.elements._btnEl.style.display = "block";
    }
  }

  handleUploaded(value) {
    const h = value.values.name;
    this.fileUploadedName = h;
    this.uploadTransactionId = guidGenerator();
    const _self = this;

    this._maxPercent = 98;

    const query = {
      uploadTransactionId: _self.uploadTransactionId,
      module: 'image-upload',
      uid: getChatURL(),
      isRetake: this.isRetake
    };

    if (this.isInsuranceUpload()) {
      query.module = 'insurance';
      const pattern = /image-upload-insurance-(.+)/
      const match = this.value.format.match(pattern);
      if (match.length > 1) {
        query.side = match[1];
      }

      if (this.value.values && this.value.values.trim) {
        const policyNumber = this.value.values.trim().toLowerCase();
        query.policyNumber = policyNumber;
      }
    }

    httpGet(url + "/api/image/process/" + h, query, function (processResult) {
      const error = processResult.error;
      //if the module has new instance from a different question, we don't want to show the error
      if(error && error.uploadTransactionId && error.uploadTransactionId === _self.uploadTransactionId) {
        _self.handleUploadError(processResult);
        return;
      }
      _self.restoreEditButtonsClick();
      console.log(processResult);
    });
  }

  handleResized(value) {
    const _self = this;
    Chat.default.send({
      id: (_self.value || {}).id,
      hash: value.name,
      status: "process",
    });
  }

  handleProcessed(value) {
    this.elements._img.onload = this.checkBlurriness(this.elements._img, value);
    this.elements._img.src = get(value, "values.file.finalURL");
  }

  // callbacks
  onUpload(file) {
    const _self = this;
    // when upload starts
    this.elements._btnEl.style.display = "none";
    this.elements._loadingBl.style.display = "block";

    this.getComponent("img.image-area").style.display = "none";
    this.getComponent("div.continue-button").parentNode.style.display = "none";
    this.getComponent("div.continue-button").parentNode.previousSibling.style.display = "none";

    this._files[0].batchId = guidGenerator();
    Chat.default.send({
      files: [{
        batchId: file.batchId,
        finalURL: file.finalURL,
        uploadURL: file.uploadURL
      }],
      id: (_self.value || {}).id,
      status: "start",
    });

    Scroller.scrollToEnd(0);
    this.initiateLoader();
  }

  onProgress(file, progress) {
    const _self = this;
    Chat.default.send({
      id: (_self.value || {}).id,
      file: { finalURL: file.finalURL, size: file.size, progress: progress },
      status: "uploading"
    });
  }

  disableSkipButton() {
    this.elements._skipBtn.classList.add('uploading');
  }

  enableSkipButton() {
    this.elements._skipBtn.classList.remove('uploading');
  }

  isInsuranceUpload() {
    return this.value && this.value.format && this.value.format.includes('image-upload-insurance');
  }

  onCompleted(file) {
    this.enableSkipButton();
    const _self = this;
    Chat.default.send(
      {
        id: (_self.value || {}).id,
        file: {
          finalURL: file.finalURL,
          mime: file.type,
          name: file.name,
          progress: 100,
          status: "completed",
        },
        status: "uploaded",
      },
      null,
      this.elContainer,
    );
  }

  onError(file, msg) {
    this.enableSkipButton();
    console.log(file, msg);
  }

  initiateLoader() {
    this._percent = 0;
    this._maxPercent = 30 + Math.floor(Math.random() * 30);

    var _self = this;

    this._interval = setInterval(function() {
      _self.elements._btnEl.style.display = "none";
      var inc = (_self._maxPercent - _self._percent) / 100;
      if (_self._percent < _self._maxPercent) {
        _self._percent += inc;
        _self.updateProgress();
      }

      if (_self.percent >= 100) {
        clearInterval(_self._interval);
      }
    }, 20);
  }

  updateProgress() {
    this.elements._percentEl.innerHTML = Math.round(this._percent) + "%";
  }

  hideAnswers() {
    this.getComponent(".option-block.controls").style.display = "none";
    this.getComponent(".option-block.form").style.display = "none";
    this.getComponent("div.continue-button").parentNode.style.display = "none";
  }

  getComponent(selector) {
    return this.elContainer.querySelector(selector);
  }

  startCapture(mediaStream) {
    if (this.elements._video) {
      this.elements._video.srcObject = mediaStream;

      const tracks = mediaStream.getTracks();
      const track = tracks.find(x => x.kind === 'video');

      const constraints = {
        resizeMode: 'crop-and-scale',
        aspectRatio: 1.333
      };

      return track.applyConstraints(constraints)
        .then(() => this.elements._video.play())
    }
  }

  showCameraFeedQuestion() {
    // Hide buttons
    this.elements._uploadActions.classList.add('inactive');
    this.elements._continue.style.display = 'none';
    this.elements._submitEl.style.display = 'none';
    this.elements._img.style.display = 'none';
    this.elements._errorServerProcessingEl.style.display = 'none';

    // Replace question
    const question = new Question({
      data: {
        text: this.language.cameraFeedText,
        subtext: this.language.cameraFeedSubtext
      }
    });
    this.elements._questionBlock.elm.innerHTML = question.getHTML().innerHTML;

    // Show camera feed
    this.elements._videoWrapper.classList.remove('inactive');

    // Show take picture button
    this.elements._takePicture.classList.remove('inactive');
  }

  takePictureAndUpload() {
    const canvas = this.elements._canvas;
    canvas.style.display = 'none';
    const video = this.elements._video;
    const context = canvas.getContext('2d');

    // Get scale based on canvas
    const scale = Math.max(canvas.width / video.videoWidth, canvas.height / video.videoHeight);
    // Get top and left position
    const x = (canvas.width / 2) - (video.videoWidth / 2) * scale;
    const y = (canvas.height / 2) - (video.videoHeight / 2) * scale;
    const sourceWidth = video.videoWidth * scale;
    const sourceHeight = video.videoHeight * scale;

    context.drawImage(video, x - 15, y, sourceWidth, sourceHeight);

    // Get image
    const fileType = 'image/png';
    const data = canvas.toDataURL(fileType);
    const blob = dataURItoBlob(data);

    // Upload blob
    const file = new File([blob], "test.png", {type:"image/png", lastModified:new Date()})
    this._files = [file];
    this.files = this._files; // just to make it work
    this.control.queue(this);
    this.control.processQueue(undefined, "aws", "nonlambda/");
  }

  closeCameraFeed() {
    for(const track of this.streamTracks) {
      if (track.readyState === 'live') {
        track.stop();
      }
    }
  }

  hideCameraFeedQuestion() {
    this.elements._videoWrapper.classList.add('inactive');
    this.elements._takePicture.classList.add('inactive');
  }
}

module.exports = ImageModule;
